import React from 'react';
const StoreCreditOrdersList = props => {
  const {
    currencyMark,
    orders,
    getOrderHistory,
    sendSMS,
    dataLocale: { ORDER, DATE, SHIP_TO, ORDER_TOTAL, SEND_CREDIT_CODE, CURRENCY_CODE },
  } = props;
  const currencyCode =
    orders && orders?.orderList?.[0]?.amount
      ? orders?.orderList?.[0]?.amount?.currencyCode
      : CURRENCY_CODE;
  const currencySymbol = currencyMark[currencyCode];
  return (
    <div className="sc-order-list">
      <table className="table table-striped">
        <thead className="thead-light">
          <tr>
            <th scope="col">{ORDER} #</th>
            <th scope="col">{DATE}</th>
            <th scope="col">{SHIP_TO}</th>
            <th colSpan="3" scope="col">
              {ORDER_TOTAL}
            </th>
          </tr>
        </thead>
        <tbody>
          {orders.orderList &&
            orders.orderList.map(order => (
              <tr key={order.id}>
                <th scope="row">
                  <span className="text-link" onClick={() => getOrderHistory(order.id)}>
                    {order.id}
                  </span>
                </th>
                <td>{new Date(order.createdAt).toString().slice(0, 15)}</td>
                <td>{`${order.shippingAddress.firstName} ${order.shippingAddress.lastName}`}</td>
                <td>
                  {currencySymbol} {order.amount.total}
                </td>
                <td>
                  {order.status.trackingStatus && order.status.trackingStatus.replace(/_/g, ' ')}
                </td>
                <td>
                  <span className="text-link" onClick={() => sendSMS(order.id)}>
                    {SEND_CREDIT_CODE}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default StoreCreditOrdersList;
